module.exports = __webpack_public_path__ + "img/subscription-packages--email.66d038c3.png";